var exports = {
  "kL": "x234b8571--5f917b--container",
  "OS": "x234b8571--5f917b--more",
  "VN": "x234b8571--5f917b--close",
  "sL": "x234b8571--5f917b--container--active",
};

module.exports = exports;
